import { ButtonMain } from '@/modules/common/components/button';
import { InputWithSign } from '@/modules/common/components/input-with-sign';
import { handleUpdate } from '@/modules/seller-account/functions/handle-update-rp.function';
import { handleSave } from '@/modules/seller-account/functions/handle-save-rp.function';
import {
  getBuyerPointsFx,
  resetPointAddress,
  searchBuyersAddressFx,
  setPointAddress,
} from '@/modules/seller-account/store/buyers.store';
import { Modal, notification, Switch } from 'antd';
import classNames from 'classnames';
import styles from './index.module.sass';
import { pointsMap as map } from '../../map.model';
import { IReceivingPoint } from '@/modules/seller-account/ts';

export const PointModal = ({
  modalVisible,
  setModalVisible,
  viewMode,
  setViewMode,
  hasMixer,
  setHasMixer,
  addressString,
  setAddressString,
  nameString,
  setNameString,
  setPointForEditId,
  pointForEditId,
  pointName,
  buyerId,
  addressOptions,
  containerDomRef,
  data,
  customCreateFoo,
  customUpdateFoo,
}: IArgs) => {
  console.log(pointName)
  return (
    <Modal
      open={modalVisible}
      onCancel={() => {
        setModalVisible(false);
        setViewMode(false);
        setAddressString('');
        setNameString('');
        setPointForEditId(-1);
      }}
      closeIcon={!viewMode && null}
      closable={true}
      className={styles.modal}
      title="пункт приема на карте"
      centered
      footer={
        !viewMode ? (
          <ButtonMain
            label="сохранить"
            className={styles.modalButton}
            onClick={async () => {
              let errors = 0;
              if (!pointName.latitude || !pointName.longitude) {
                errors++;
                notification.warning({ message: 'Не указаны координаты ППЗ' });
              }
              if (!addressString) {
                errors++;
                notification.warning({ message: 'Не заполнено поле "адрес"' });
              }
              if (errors > 0) return;

              pointForEditId > -1
                ?  !customUpdateFoo ? await handleUpdate({
                    nameString,
                    hasMixer,
                    pointName: {
                      ...pointName,
                      latitude: pointName.latitude,
                      longitude: pointName.longitude,
                    },
                    pointForEditId,
                    clearValue: () => setPointForEditId(-1),
                  }) : await customUpdateFoo({
                    nameString,
                    hasMixer,
                    pointName: {
                      ...pointName,
                      latitude: pointName.latitude,
                      longitude: pointName.longitude,
                    },
                    pointForEditId,
                    clearValue: () => setPointForEditId(-1),
                  })
                : !customCreateFoo ? await handleSave({
                    nameString,
                    pointName,
                    hasMixer,
                    buyerId,
                    setModalVisible,
                    setAddressString,
                  }) : customCreateFoo({
                    nameString,
                    pointName,
                    hasMixer,
                    buyerId,
                    setModalVisible,
                    setAddressString,
                  });
              setModalVisible(false);
              setNameString('');
              !customCreateFoo && !customUpdateFoo && await getBuyerPointsFx(buyerId);
            }}
          />
        ) : (
          []
        )
      }
      width={'80%'}
    >
      {!viewMode && (
        <InputWithSign
          value={nameString}
          onChange={(e) => setNameString(e.target.value)}
          placeholder="не задано"
          label="название пункта приема"
          postfix=""
        />
      )}
      {!viewMode ? (
        <InputWithSign
          className={styles.field}
          value={addressString}
          label="адрес*"
          placeholder="не задано"
          postfix=""
          onChange={(e) => {
            // handleChange('address', e.target.value);
            setAddressString(e.target.value);
            searchBuyersAddressFx(e.target.value);
          }}
          options={
            Array.isArray(addressOptions)
              ? addressOptions
                  ?.map((item: any) => ({ label: item.value }))
                  .filter((item: { label: string }) => item.label)
                  .filter(
                    (value: { label: string }, index: number, self: any) =>
                      index ===
                      self.findIndex(
                        (obj: any) => JSON.stringify(obj) === JSON.stringify(value),
                      ),
                  )
              : []
          }
          onOptionSelect={async (val: string) => {
            const selectedOption = addressOptions.find(
              (item: any) => item.value === val,
            );
            
            setAddressString(selectedOption);
            const coords = await map.setMarkerByAddress(val, pointName);
            setPointAddress({
              ...pointName,
              region: selectedOption.region,
              area: selectedOption.city,
              street: selectedOption.street,
              house: selectedOption.house,
              coordinates: coords ? JSON.stringify(coords) : '',
              latitude: coords?.[0] || '',
              longitude: coords?.[1] || '',
            });
            
          }}
        />
      ) : (
        <></>
      )}
      { !viewMode && <>
      <span className={styles.mixerTitle}>доп.опции</span>
      <div className={styles.mixer} onClick={() => setHasMixer(hasMixer === 0 ? 1 : 0)}>
        <span>На ППЗ имеется производственный миксер: </span>
        <Switch checked={hasMixer === 1 ? true : false}/>
      </div></> }
      <figure className={styles.map}>
        <div
          className={classNames(styles.container, styles.viewContainer)}
          id="yviewer"
          ref={containerDomRef}
        />
      </figure>
    </Modal>
  );
};

interface IArgs {
  modalVisible: boolean;
  setModalVisible: (val: boolean) => void;
  viewMode: boolean;
  setViewMode: (val: boolean) => void;
  addressString: string;
  setAddressString: (val: string) => void;
  nameString: string;
  setNameString: (val: string) => void;
  setPointForEditId: (val: number) => void;
  pointForEditId: number;
  setHasMixer: (val: number) => void;
  hasMixer: number;
  pointName: IReceivingPoint;
  buyerId: number;
  addressOptions: any;
  containerDomRef: React.MutableRefObject<any>;
  data: any;
  customCreateFoo?: (dto: any) => Promise<unknown>,
  customUpdateFoo?: (dto: any) => Promise<unknown>,
}
